export default __webpack_public_path__ + "static/media/metamask_setup.8eceba33.jpeg";